"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _DeleteSweep2 = _interopRequireDefault(require("@material-ui/icons/DeleteSweep"));

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Delete2 = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _VerticalAlignBottom2 = _interopRequireDefault(require("@material-ui/icons/VerticalAlignBottom"));

var _VerticalAlignTop2 = _interopRequireDefault(require("@material-ui/icons/VerticalAlignTop"));

require("./styles.css");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactContextmenu = require("react-contextmenu");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RowMenu = function RowMenu(_ref) {
  var handleDelete = _ref.handleDelete,
      selectedRows = _ref.selectedRows,
      handleDeleteSelected = _ref.handleDeleteSelected;
  var buttonData = [{
    icon: /*#__PURE__*/_react["default"].createElement(_VerticalAlignTop2["default"], {
      fontSize: "small"
    }),
    text: "Insert Record Above",
    func: function func() {}
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_VerticalAlignBottom2["default"], {
      fontSize: "small"
    }),
    text: "Insert Record Below",
    func: function func() {}
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Delete2["default"], {
      fontSize: "small"
    }),
    text: "Delete Record",
    func: handleDelete
  }];
  return /*#__PURE__*/_react["default"].createElement(_reactContextmenu.ContextMenu, {
    id: "grid-context-menu"
  }, buttonData.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_reactContextmenu.MenuItem, {
      key: index,
      onClick: function onClick(_, data) {
        item.func(data.id);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        alignItems: "center"
      }
    }, item.icon, /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
      style: {
        marginLeft: 8,
        fontSize: "0.875rem"
      }
    }, item.text)));
  }), (selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.size) > 0 && /*#__PURE__*/_react["default"].createElement(_reactContextmenu.MenuItem, {
    onClick: handleDeleteSelected
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_DeleteSweep2["default"], {
    fontSize: "small"
  }), /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
    style: {
      marginLeft: 8,
      fontSize: "0.875rem"
    }
  }, "Delete Selected Records"))));
};

var _default = RowMenu;
exports["default"] = _default;
RowMenu.defaultProps = {
  handleDelete: function handleDelete() {},
  handleDeleteSelected: function handleDeleteSelected() {},
  selectedRows: []
};
RowMenu.propTypes = {
  handleDelete: _propTypes["default"].func,
  handleDeleteSelected: _propTypes["default"].func,
  selectedRows: _propTypes["default"].array
};